<template lang="pug">
  .order-details
    .table.table_order-details
      .table__header
        .table__row
          .table__col.table__head(v-for='(item, index) in order' :key="'header-' + index" :style="getStyle(item)") {{meta[item]?.label}}
      .table__body
        .table__row(v-for="(item, i) in items" :key="'block-'+i")
          .table__col(v-for='(point, index) in order' :key="'body-' + index" :style="getStyle(point)") {{item[point]}}
        .table__row.table__row_sticky
          .table__col(:style="getStyle('row_number')") Всего
          .table__col(v-for='(empty, index) in emptyTotal' :style="getStyle(empty)" :key="'empty-' + index" )
          .table__col(v-for='(item, index) in totalOrder' :style="getStyle(item)" :key="'total-' + index" ) {{total[item]}}
</template>

<script>
import { report } from '@/api/api-endpoints'
import urlUtil from '@/utils/url'

const widths = {
  row_number: 100,
  waste_type_name: 200,
  waste_code: 180,
  danger: 90,
  solid_waste_formation: 200,
  solid_waste_processed: 200,
}
const emptyTotal = ['waste_type_name', 'waste_code', 'danger']
const order = [
  'row_number',
  'waste_type_name',
  'waste_code',
  'danger',
  'avail_waste_after_processing_at_year_end',
  'solid_waste_formation',
  'total_solid_waste',
  'total_solid_waste_inc_subj',
  'solid_waste_processed',
  'total_solid_waste_formation_after_processed',
  'subj_solid_waste_formation_after_processed',
  'regop_solid_waste_formation_after_processed',
  'own_solid_waste_formation_after_processed',
  'total_solid_waste_utilized',
  'solid_waste_energy_utilized',
  'solid_waste_defused',
  'total_solid_waste_transfer',
  'solid_waste_transfer_subj',
  'total_solid_waste_transfer_utilization',
  'solid_waste_transfer_energy_utilization',
  'solid_waste_transfer_subj_energy_utilization',
  'solid_waste_transfer_subj_utilization',
  'total_solid_waste_transfer_defused',
  'solid_waste_transfer_subj_defused',
  'total_solid_waste_transfer_burial',
  'solid_waste_transfer_subj_burial',
  'solid_waste_processing_storage',
  'solid_waste_burial',
  'end_of_reporting_period_solid_waste',
]

export default {
  name: 'order-details',
  data() {
    return {
      items: [],
      total: {},
      meta: {},
      order,
      emptyTotal,
    }
  },
  computed: {
    totalOrder() {
      return [...this.order].slice(4)
    },
  },
  methods: {
    async getDetails() {
      const prevRoute = urlUtil.encode(urlUtil.getPrevRoute(this.$route))
      const data = await (
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint: report.order285Detail(this.$route.params.id, {
            query: { year: prevRoute.query.year, 'per-page': -1 },
          }),
        })
      ).data
      this.items = data.data.rows
      this.total = data.data.totals
      this.meta = data._meta
    },
    getStyle(attr) {
      const defaultWidth = 300
      return {
        'min-width': `${widths[attr] || defaultWidth}px`,
        'max-width': `${widths[attr] || defaultWidth}px`,
      }
    },
  },
  created() {
    this.getDetails()
  },
}
</script>

<style scoped lang="scss">
.table {
  &_order-details {
    max-height: calc(90vh - 45px - 125px);

    .table {
      &__col {
        min-width: 95px;
        max-width: 200px;
        flex-grow: initial;
      }

      &__row {
        &_sticky {
          position: sticky;
          bottom: 0;
        }
      }
    }
  }
}
</style>
